import PropTypes from "prop-types";
import withViewport from "../Viewport/withViewport";
import { withTranslation } from "@template/components/translation";
import classnames from "classnames";
import styles from "./index.css";
import { useGetAppDownloadUrl } from "../../utils/hooks/useGetAppDownloadUrl";
import NameRating from "./NameRating";
import Button from "../Button";
import AppLogo from "./AppLogo";
import { handleDownloadApp } from "@template/helpers/handleDownloadApp";

const AppDownload = ({
  isAccordion,
  formatTranslation,
  countryCode,
  ctaRef
}) => {
  const { appDownloadUrl, osPlatform, isLoading } = useGetAppDownloadUrl({
    countryCode,
    ctaRef
  });

  const handleDownloadAppCta = e => {
    e.preventDefault();
    if (!appDownloadUrl || isLoading) return;
    handleDownloadApp({
      osPlatform,
      appDownloadUrl
    });
  };

  return (
    <div
      className={classnames(styles.container, {
        [styles.sideNavigation]: isAccordion
      })}
      data-testid="app-download"
    >
      <div className={styles.logoContainer}>
        <AppLogo classes={styles.appLogo} />
        <NameRating isAccordion={isAccordion} />
      </div>
      <div className={styles.ctaContainer}>
        <Button
          onClick={handleDownloadAppCta}
          classes={styles.ctaButton}
          theme="primary"
          disabled={isLoading || !appDownloadUrl}
        >
          {formatTranslation("app_download_cta")}
        </Button>
      </div>
    </div>
  );
};

AppDownload.propTypes = {
  isAccordion: PropTypes.bool,
  formatTranslation: PropTypes.func,
  countryCode: PropTypes.string,
  ctaRef: PropTypes.string
};

export default withViewport(withTranslation(AppDownload));
